import "react-toastify/dist/ReactToastify.css";
import "@/index.css";
import { mfeRenderBuilder } from "@/components/mfe-render-builder/mfeRenderBuilder";
import { MfeWrapperApp } from "@/MfeWrapperApp";

export const { render, cleanup } = mfeRenderBuilder(MfeWrapperApp);
